export default __webpack_public_path__ + "static/media/Dd.302cbddb.wav";